import React from 'react';
import PropTypes from 'prop-types';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import Component from '@plone/volto/components/theme/Component/Component';
import ContentImage from '../Image/ContentImage';
import Copyright from '../Image/Copyright';
import { eventDetails, newsDate } from './dates';
import ContactCard from './ContactCard';

import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';

// Based on Volto's SummaryTemplate; query, batching and controls stay upstream.
const CardTemplate = ({
  items,
  linkTitle,
  linkHref,
  isEditMode,
  variation,
}) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  return (
    <>
      <ul className={`bonn-listing bonn-listing-${variation}`}>
        {items.map((item) => {
          const event = variation === 'events' ? eventDetails(item) : null;
          const date = newsDate(item.effective);
          return (
            <li className="bonn-listing-item" key={item['@id']}>
              {variation === 'contacts' ? (
                <ContactCard item={item} isEditMode={isEditMode} />
              ) : (
                <ConditionalLink item={item} condition={!isEditMode}>
                  <article className="bonn-entry">
                    <figure className="bonn-entry-media">
                      <ContentImage
                        fallback="listing"
                        component={Component}
                        componentName="PreviewImage"
                        item={item}
                        alt=""
                        loading="lazy"
                        responsive
                      >
                        <Copyright>{item.copyright}</Copyright>
                      </ContentImage>
                    </figure>
                    <div className="bonn-entry-body">
                      {event?.date && (
                        <time className="bonn-event-date" dateTime={item.start}>
                          {event.date}
                        </time>
                      )}
                      <h3 className="bonn-entry-title">
                        {item.title || item.id}
                      </h3>
                      {event?.meta && (
                        <div className="bonn-event-meta">{event.meta}</div>
                      )}
                      <div className="bonn-entry-text">{item.description}</div>
                      {!event && (
                        <div className="bonn-news-footer">
                          {date && (
                            <time dateTime={item.effective}>{date}</time>
                          )}
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                          >
                            <path d="M4 12h16m-6-6 6 6-6 6" />
                          </svg>
                        </div>
                      )}
                    </div>
                  </article>
                </ConditionalLink>
              )}
            </li>
          );
        })}
      </ul>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

CardTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
  variation: PropTypes.string,
};

export default CardTemplate;
